import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		abrirNovaConsulta: false,
		refreshList:'',
		consultaIntIndice: '',
		token:'',
		areas: [],
		idUsuario: '',
		paginaAtual:1,
		pesquisaPalavra:'',
		idAreaLista:'',
		idTema:'',
		limitePagina:'',
		loadingConsultas:true,
		emails: [],
		dadosSolicitante: {
			nome: '',
			telefone: '',
			cidade: '',
			uf: '',
			emails: [],
		},
		currentConsulta: {intIndice:''}
	},
	mutations: {
		updateConsulta(state, consulta){
			
			state.consultaIntIndice = consulta
 		}
	},
	actions: {},
	modules: {}
})

